module.exports = __webpack_public_path__ + "static/img/bg-18.5849ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-18.png
// module id = IAqJ
// module chunks = 0